// extracted by mini-css-extract-plugin
export default {"more":"fjtjfe","moreIcon":"zg6Bj_","icon":"hqvZcS","container":"PBSpYk","wutPopover":"NYZpBF"};